import { style } from "typestyle";

export const container = style({
  padding: "1rem",
  border: `1px solid rgba(213, 218, 230, 1)`,
  display: "flex",
  borderRadius: 12,
});

export const icon = style({
  // width: 40,
  // height: 40,
  // border: `1px solid ${colors.grey[300]}`,
  // backgroundColor: colors.grey[100],
  // borderRadius: 7,
  marginRight: "1rem",
});

export const textWrapper = style({ flex: 1 });

export const title = style({
  fontWeight: 600,
  marginBottom: "0.2rem",
  fontSize: "0.9rem",
});
export const content = style({
  fontSize: "0.85rem",
});
